import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Button, Typography, TextField, Select, MenuItem, Grid } from "@material-ui/core";
import { EmojiEvents, Save } from "@material-ui/icons";

import { gradeInternationalLevel } from "../../../../reducer/studentResearch/action";
import { SCHOOL_LEVEL_RESULT_OPTIONS, CONFERENCE_RESULT_PARTICIPATE } from "../../../../constants/projectStatus";
import SectionCard from "../../utils/SectionCard";
import LevelNoteField from "../../utils/LevelNoteField";

// InternationalLevelForm — Phòng QLKH cập nhật kết quả cấp Quốc tế. Cấp cuối
// cùng — không có lựa chọn đề xuất tiếp (international_level_pending).
export default function InternationalLevelForm({ detail, onDone }) {
  const dispatch = useDispatch();
  const [prize, setPrize] = useState(detail?.internationalLevelPrize || CONFERENCE_RESULT_PARTICIPATE);
  const [comment, setComment] = useState(detail?.internationalLevelComment || "");
  const [note, setNote] = useState(detail?.internationalLevelNote || "");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setPrize(detail?.internationalLevelPrize || CONFERENCE_RESULT_PARTICIPATE);
    setComment(detail?.internationalLevelComment || "");
    setNote(detail?.internationalLevelNote || "");
  }, [detail?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSave = async () => {
    setSaving(true);
    try {
      const ok = await dispatch(gradeInternationalLevel(detail.id, { prize, comment, note }));
      if (ok && onDone) onDone();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box padding="16px 24px">
      <SectionCard icon={<EmojiEvents />} title="Cập nhật kết quả cấp Quốc tế" marginTop={0}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6}>
            <Typography variant="body2" style={{ marginBottom: 6 }}>
              Xếp loại <span style={{ color: "#c62828" }}>*</span>
            </Typography>
            <Select
              fullWidth
              variant="outlined"
              margin="dense"
              value={prize}
              onChange={(e) => setPrize(e.target.value)}
            >
              {SCHOOL_LEVEL_RESULT_OPTIONS.map((o) => (
                <MenuItem key={o.value} value={o.value}>
                  {o.label}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" style={{ marginBottom: 6 }}>
              Nhận xét
            </Typography>
            <TextField
              fullWidth
              multiline
              minRows={3}
              variant="outlined"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </Grid>
          <LevelNoteField value={note} onChange={setNote} />
        </Grid>
      </SectionCard>

      <Box
        marginTop={3}
        paddingTop={2}
        display="flex"
        justifyContent="flex-end"
        borderTop="solid 1px #e0e0e0"
      >
        <Button
          variant="contained"
          color="primary"
          disabled={saving}
          onClick={handleSave}
          startIcon={<Save />}
        >
          Lưu kết quả cấp Quốc tế
        </Button>
      </Box>
    </Box>
  );
}
